import React, { useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import DragDropComponente from '../../../componentes/dragdrog/dragdrop.componente';
import ButtonFloating from '../../../componentes/button/button-floating.component';
import CitologiaFiltroPage from './citologia.filtro.page';
import CitologiaModalPage from './citologia.modal.page';
import NConformidadeContainer from '../../histologia/common/modais/nconformidade/nconformidade.container';
import CitologiaApagarModalPage from './citologia.apagar.modal.page';
import EtiquetaEmLoteComponent from '../../histologia/common/etiqueta.lote.component';
import DelegacaoComponent from '../../histologia/common/delegacao_laminas/delegacao.component';
import CitologiaCassetesContainer from './citologia.cassetes.container';
import { acessoPermitido } from '../../../acessos.seguranca';
import * as acessos from '../../../acessos.const.util';
import './citologia.styles.css';
import { useIntl } from 'react-intl';
import CitologiaEditModalPage from './citologia.edit.modal.page';

const CitologiaPage = (props) => {
  const intl = useIntl();
  const [periodoInicial, setPeriodoInicial] = useState()
  const [periodoFinal, setPeriodoFinal] = useState()
  function translate(key) {
    return intl.formatMessage({ id: key });
  }

  const floatingBtn = [
    {
      className: 'fas fa-layer-group',
      backgroundColor: '#3f8642',
      color: '#ffffff',
      texto: translate('dashboards.cytology.toAddBlades'),
      onClick: props.botaoFlutuanteAdicionarLamina
    },
    {
      className: 'fas fa-pager',
      backgroundColor: '#f44336',
      color: '#ffffff',
      texto: translate('dashboards.cytology.addCassete'),
      onClick: props.toggleModalMapaMacroscopico
    },
    {
      className: 'mv-basico-codigo_barras',
      backgroundColor: '#2196f3',
      color: '#ffffff',
      texto: translate('dashboards.cytology.batchLabels'),
      onClick: props.toggleModalImprimirEtiquetaEmLote
    }
  ];

  if (
    acessoPermitido(props.usuario, acessos.DelegacaoLaminas),
    acessoPermitido(props.usuario, 'DelegacaoLaminas')
  ) {
    floatingBtn.push({
      className: 'fas fa-exchange-alt',
      backgroundColor: '#f44336',
      color: '#ffffff',
      texto: translate('dashboards.cytology.delegationBlades'),
      onClick: props.toggleModalDelegacaoLaminas
    });
  }

  return (
    <div className='citologia-page'>
      {props.showModalMapaMacroscopico && (
        <CitologiaCassetesContainer
          intl={intl}
          open={props.showModalMapaMacroscopico}
          toggle={props.toggleModalMapaMacroscopico}
        />
      )}
      {props.showModalDelegacaoLaminas && (
        <DelegacaoComponent
          showModal={props.showModalDelegacaoLaminas}
          toggleModal={props.toggleModalDelegacaoLaminas}
        />
      )}
      {props.showModalImprimirEtiquetaEmLote && (
        <EtiquetaEmLoteComponent
          showModal={props.showModalImprimirEtiquetaEmLote}
          toggleModal={props.toggleModalImprimirEtiquetaEmLote}
          imprimirEtiquetas={props.imprimirEtiquetaEmLote}
          laminasParaEtiqueta={props.laminasParaEtiqueta}
        />
      )}
      {props.modalOpenNaoConfor && (
        <NConformidadeContainer
          intl={intl}
          open={props.modalOpenNaoConfor}
          toggle={props.toggleModalNaoConfor}
          item={props.itemInModal}
          naoconformidades={props.naoconformidades}
          usuarioLocal={props.usuarioLocal}
          callBackConclusaoInclusaoResolucaoNConformidade={
            props.callBackConclusaoInclusaoResolucaoNConformidade
          }
        />
      )}
      {props.modalOpenCancelar && (
        <CitologiaApagarModalPage
          open={props.modalOpenCancelar}
          toggle={props.toggleModalCancelar}
          label={props.itemInModalCancelar.label}
          cancelarItem={props.apagarLaminaCitologia}
          justificativaParaCancelamento={props.justificativaParaCancelamento}
          preencherJustificativaParaCancelamento={
            props.preencherJustificativaParaCancelamento
          }
        />
      )}
      <CitologiaModalPage
        open={props.isShowModalAdicionarLamina}
        toggle={props.showModalAdicionarLamina}
        qtdLaminas={props.qtdLaminas}
        complememtoLamina={props.complememtoLamina}
        complementos={props.complementos}
        setComplementos={props.setComplementos}
        laudo={props.laudo}
        nr_exame={props.nr_exame}
        patologistas={props.patologistas}
        patologista={props.patologista}
        tecnicos={props.tecnicos}
        tecnico={props.tecnico}
        alterarValorState={props.alterarValorState}
        adicionarLamina={props.adicionarLamina}
        handleCreateSelectCreatable={props.handleCreateSelectCreatable}
        exame={props.exame}
        paciente={props.paciente}
        prontuario={props.prontuario}
        blocosCitologia={props.blocosCitologia}
        blocoCitologia={props.blocoCitologia}
        laudoNaoExiste={props.laudoNaoExiste}
        dataInclusaoLamina={props.dataInclusaoLamina}
        naoconformidades={props.naoconformidades}
        nConfInclusaoLamina={props.nConfInclusaoLamina}
        laudoRef={props.laudoRef}
        pesquisaNumExame={props.pesquisaNumExame}
        limparCamposAdicionarLaminas={props.limparCamposAdicionarLaminas}
      />
      <CitologiaEditModalPage
        open={props.isShowModalEditarLamina}
        toggle={props.showModalEditarLamina}
        laminaSelecionada={props.laminaSelecionada}
        setState={props.setState}
        commonActions={props.commonActions}
        complememtoLamina={props.complememtoLamina}
        complementos={props.complementos}
        setComplementos={props.setComplementos}
        patologistas={props.patologistas}
        patologista={props.patologista}
        buscar={props.buscar}
        handleCreateSelectCreatable={props.handleCreateSelectCreatable}
      />
      <Container fluid>
        <Row>
          <Col>
            <CitologiaFiltroPage
              limparFiltro={props.limparFiltro}
              tecnicos={props.tecnicos}
              tecnicoSelecionado={props.tecnicoSelecionado}
              periodoInicial={props.periodoInicial}
              periodoFinal={props.periodoFinal}
              onChangeData={props.onChangeData}
              setPeriodoInicial={setPeriodoInicial}
              setPeriodoFinal={setPeriodoFinal}
              onChangeTecnico={props.onChangeTecnico}
              onChangeNumeroExame={props.onChangeNumeroExame}
              onChangeLaudo={props.onChangeLaudo}
              onKeyPressNumeroExame={props.onKeyPressNumeroExame}
              onKeyPressLaudo={props.onKeyPressLaudo}
              numeroDoExame={props.numeroDoExame}
              laudoPesquisa={props.laudoPesquisa}
              onClickSearch={props.buscar}
              onClickOrganize={props.organizar}
              onClickOrdem={props.onClickOrdem}
              sortAsc={props.sortAsc}
              periodos={props.periodos}
							periodo={props.periodo}
							onChangePeriodo={props.onChangePeriodo}
							mudarIntervaloPeriodo={props.mudarIntervaloPeriodo}
							onKeyPressData={props.onKeyPressData}
              onChangeNumeroPedido={props.onChangeNumeroPedido}
							onKeyPressNumeroPedido={props.onKeyPressNumeroPedido}
							numeroDoPedido={props.numeroDoPedido}
            />
          </Col>
        </Row>
        <Row>
          <DragDropComponente
            {...props}
            list={props.listaKanbam}
            onDragEndOverride={props.onDragEndOverride}
            onChangePeriodo={props.onChangePeriodo}
            periodoInicial={periodoInicial}
            periodoFinal={periodoFinal}
            buscar={props.buscar}
          />
          <ButtonFloating actions={floatingBtn} />
        </Row>
      </Container>
    </div>
  );
};

export default CitologiaPage;



// WEBPACK FOOTER //
// ./src/pages/citologia/content/citologia.page.js